import * as Yup from 'yup';
import moment from 'moment';

export const filtrosSchema = Yup.object().shape({
  dataInicio: Yup.date()
    .typeError('Data inicial invalida.')
    .required('Data inicial deve ser informada.'),
  dataFim: Yup.date()
    .typeError('Data final invalida.')
    .required('Data final deve ser informada.')
    .test('periodo-valido', 'Data inicial deve ser menor ou igual a data final.', function (value) {
      const dataInicio = this.parent && this.parent.dataInicio;
      if (!dataInicio || !value) return true;
      return moment(dataInicio).isSameOrBefore(moment(value), 'day');
    }),
  grupoEmpresaId: Yup.number().nullable(),
  contaId: Yup.number().nullable(),
  aprovadorId: Yup.number().nullable(),
  valorMinimo: Yup.number()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable()
    .min(0, 'Valor minimo deve ser maior ou igual a zero.'),
  // GAP-03: paridade Delphi URelDespesasAnalitico.pas:240-262 — moeda obrigatoria se houver valor minimo
  moedaFiltroId: Yup.number().nullable().test(
    'moeda-obrigatoria-com-valor-minimo',
    'Selecione uma moeda quando informar valor minimo.',
    function (value) {
      const valor = this.parent && this.parent.valorMinimo;
      if (valor != null && Number(valor) > 0 && (value == null || value === '')) return false;
      return true;
    }
  ),
  centroCustoId: Yup.number().nullable(),
  departamentoId: Yup.number().nullable(),
  ocultarContasParametrizadas: Yup.boolean(),
  apenasNaoAprovados: Yup.boolean(),
  ocultarContasBancos: Yup.boolean(),
  incluirContasInternas: Yup.boolean(),
});
